import { useLanguage } from "@digipost/translate";
import React from "react";

import styles from "./Logo.module.less";

const Logo: React.FC = () => {
  const { language } = useLanguage();

  return (
    <a
      href={"/" + (language === "nb" ? "" : language)}
      className={styles.headerLogoLink}
    >
      <img
        src={"/images/logo/digipost_logo_stor.svg"}
        alt=""
        className={styles.logoDigipost}
      />
      <img
        src={"/images/logo/digipost_logo_liten.svg"}
        alt=""
        className={styles.logoDigipostMobil}
      />
    </a>
  );
};

export default Logo;
